/**
 * General state selectors
 */
export const getErrorCode = state => state.caseLog.errorCode;
